import styles from "./Background.module.css";

import background from "../../../media/Rush/rushbanner.png";

const BackgroundJoin = () => {
    return(
        <article
        className={styles.article}
        style={{ backgroundImage:  `url(${background})` }}>
            <h1 className={styles.header}>Rush</h1>
            <h4 className={styles.headersmtxt}>Join us for our Spring '24 Rush!</h4>
        </article>
    );
};

export default BackgroundJoin;